import { setActiveUsersList, setActiveUsersRowCount } from '@/store';
import { ACTIVE_USERS_LIST_TAG } from '../constants';
import { api } from '../core';

export interface ActiveUserData {
  createdAt: string;
  userEmail: string;
  userFirstName: string;
  userId: string;
  userLastName: string;
  userName: string;
  userRole: string; // UI adopted UserRoleType;
}

export interface GetActiveUsersResponse {
  numberOfUsers: number;
  users: ActiveUserData[];
}

export interface GetActiveUsersRequest {
  pageIndex: number;
  pageSize: number;
  name?: string;
}

const getActiveUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getActiveUsers: builder.query<GetActiveUsersResponse, GetActiveUsersRequest>({
      query: ({ pageIndex, pageSize, name }: GetActiveUsersRequest) => ({
        url: `users`,
        method: 'GET',
        params: { pageIndex: pageIndex, pageSize: pageSize, name: name },
      }),
      providesTags: (_result, _error, { pageIndex, pageSize }) => [
        { type: ACTIVE_USERS_LIST_TAG, id: `${pageIndex}-${pageSize}` },
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setActiveUsersList(data.users));
            dispatch(setActiveUsersRowCount(data.numberOfUsers));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getCaseDocuments in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 3 },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyGetActiveUsersQuery } = getActiveUsersApi;
